import { render, staticRenderFns } from "./ObjektiCard2Tab-10-Pozicije.vue?vue&type=template&id=a725925a&"
import script from "./ObjektiCard2Tab-10-Pozicije.vue?vue&type=script&lang=ts&"
export * from "./ObjektiCard2Tab-10-Pozicije.vue?vue&type=script&lang=ts&"
import style0 from "./ObjektiCard2Tab-10-Pozicije.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports